/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconOverline = createReactComponent("overline", "IconOverline", [
  ["path", { d: "M7 9v5a5 5 0 0 0 10 0v-5", key: "svg-0" }],
  ["path", { d: "M5 5h14", key: "svg-1" }]
]);

export { IconOverline as default };
//# sourceMappingURL=IconOverline.js.map
